module.exports = __webpack_public_path__ + "img/livebtn.99d34949.svg";